import '@fontsource-variable/geist'
import '@fontsource-variable/geist-mono'
import './styles.css'

import { MutationCache, QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { createRouter, RouterProvider } from '@tanstack/react-router'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { toast } from 'sonner'
import { ApiRequestError, errorMessage } from './lib/api'
import { watchForNewBuild } from './lib/build-refresh'
import { routeTree } from './routeTree.gen'

watchForNewBuild()

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      retry: (failures, error) =>
        failures < 2 &&
        !(error instanceof ApiRequestError && error.statusCode >= 400 && error.statusCode < 500),
    },
  },
  mutationCache: new MutationCache({
    // Toda mutación sin manejador propio muestra su error: nunca se falla en silencio.
    onError: (error, _vars, _ctx, mutation) => {
      if (mutation.options.onError) return
      toast.error(errorMessage(error))
    },
  }),
})

const router = createRouter({
  routeTree,
  context: { queryClient },
  defaultPreload: 'intent',
  defaultPreloadStaleTime: 0,
  scrollRestoration: true,
})

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
  interface StaticDataRouteOption {
    /** Texto de la ruta en las migas de pan. */
    crumb?: string
  }
}

const root = document.getElementById('root')
if (!root) throw new Error('Falta #root')

createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </StrictMode>,
)
